import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TipoResolucion } from '../models/t2_tiporesolucion.model';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TiposresolucionesService {

  constructor(private http: HttpClient) { }

  getToken(): string {
    return <string>localStorage.getItem('access_token');
  }

  // Método para crear headers con el token
  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Authorization': `Bearer ${this.getToken()}`
    });
  }

  // Métodos para paginación
  getPages(pageSize: number, usuario: TipoResolucion): Observable<any> {
    const headers = this.getHeaders();
    let params = new HttpParams();
    params = params.append('index', usuario.Name);
    params = params.append('size', pageSize);
    return this.http.get<any>(`${environment.apiUrl}/tiposresoluciones/paginar`, { headers, params });
  }

  getDataId(usuario: TipoResolucion): Observable<TipoResolucion> {
    const headers = this.getHeaders();
    return this.http.get<TipoResolucion>(`${environment.apiUrl}/tiposresoluciones/${usuario.Id}`, { headers });
  }

  getDataFilter(page: any, filtro: TipoResolucion): Observable<TipoResolucion[]> {
    const headers = this.getHeaders();
    let params = new HttpParams();
    params = params.append('index', filtro.Name);
    if(page!=0){
      params = params.append('size', page.size);
      params = params.append('offset', page.offset);
    }
    return this.http.get<TipoResolucion[]>(`${environment.apiUrl}/tiposresoluciones`, { headers, params });
  }

  postData(demostracion: TipoResolucion): Observable<any> {
    const headers = this.getHeaders();
    const formData = new FormData();
    formData.append('data', JSON.stringify(demostracion));
    return this.http.post<any>(`${environment.apiUrl}/tiposresoluciones`, formData, { headers });
  }

  putData(usuario: TipoResolucion): Observable<any> {
    const headers = this.getHeaders();
    const formData = new FormData();
    formData.append('data', JSON.stringify(usuario));
    return this.http.put<any>(`${environment.apiUrl}/tiposresoluciones/${usuario.Id}`, formData, { headers });
  }

  deleteData(usuario: TipoResolucion): Observable<any> {
    const headers = this.getHeaders();
    return this.http.delete<any>(`${environment.apiUrl}/tiposresoluciones/${usuario.Id}`, { headers });
  }

}
